import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from './../../../../../../core/toast.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { AddSupplyCategoryService } from '../../services/add-supply-category.service';

@Component({
  selector: 'app-add-supply-category',
  templateUrl: './add-supply-category.component.html',
  styleUrls: ['./add-supply-category.component.scss']
})
export class AddSupplyCategoryComponent implements OnInit {

  supplyCategoryForm = this.fb.group({
    name: [null, [Validators.required]]
  })

  constructor(
    private fb: FormBuilder,
    private addSupplyCategoryService: AddSupplyCategoryService,
    private toast: ToastService,
    private matDialogRef: MatDialogRef<AddSupplyCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    if(this.data && this.data.name){
      this.name.setValue(this.data.name);
    }
  }


  async addSupplyCategory(){
    if(this.supplyCategoryForm.invalid){
      this.toast.openSnackBar('Please enter valid name');
      this.supplyCategoryForm.markAllAsTouched();
      return;
    }
    const supplyCategory = this.supplyCategoryForm.value as any;
    try {
      const response = await this.addSupplyCategoryService.addSupplyCategory(supplyCategory);
      this.toast.openSnackBar('Category added successfully');
      this.closeDialog(response);
    } catch(error){
      this.toast.openSnackBar('Unable to add category');
    }

  }

  closeDialog(status: any){
        document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this.matDialogRef.close(status); }, 1000);
  }

  /* --------------------------------- Getters -------------------------------- */

  get name(){
    return this.supplyCategoryForm.get('name')
  }
}
